<script>
	import Hosting from './components/Hosting.svelte';
	import CarePlans from './components/CarePlans.svelte';
	import Total from './components/Total.svelte';
	import Faq from './components/Faq.svelte';

	//import logo from '/public/assets/logo-laugau.com'
</script>

<header>
	<img src="assets/logo-laugau.svg" alt="Logo LauGau">
</header>
<main>
	<div class="section-offers">
		<h2>#1 Selectionnez votre hébergement</h2>
		<Hosting/>
		<h2>#2 Selectionnez votre pack de maintenance</h2>
		<CarePlans/>
	</div>
	<div class="section-faq">
		<h2>FAQ</h2>
		<Faq/>
	</div>
	<div>
		<h2>#3 Passez commande</h2>
		<img class="arrow-down" src="assets/arrow-down.svg" alt="Flèche vers le bas">
	</div>
</main>
<aside class="section-total">
	<Total/>
</aside>

<style>
	h2 {
		padding-top: 60px;
		padding-bottom: 40px;
	}
	.section-offers{
		padding: 20px;
	}
	.section-total {
		position: fixed;
		bottom: 0;
		width: 100%;
		padding: 40px;
		background: linear-gradient(transparent, hsla(216, 65%, 18%, 0.25));
		background: linear-gradient(transparent, hsla(60, 38%, 94%, 1));
		text-align: center;
	}
	main {
		text-align: center;
		padding: 0 20px;
		margin: 0 auto;
		width: 100%;
		padding-bottom: 150px;
		max-width: 1600px;
	}
	:global(body) {
		padding: 0;
		margin: 0;
		font-family: Georgia, 'Times New Roman', Times, serif;
		color: #10284B;
		background: #F6F6EB;
	}
	:global(*){
		box-sizing: border-box;
	}
	header {
		position: fixed;
		padding: 0 40px;
		z-index: 1;
		width: 100%;
	}
	header img {
		width: 200px;
	}
	.arrow-down {
		opacity: 0.25;
	}
	@media all and (max-width: 900px) {
        header {
            text-align: center;
        }
    }
    @media all and (max-width: 550px) {
		main {
			padding-bottom: 0px;
		}
		.section-total {
			position: static;
			margin-bottom: 40px;
		}
	}
</style>